export default "__VITE_ASSET__B9yd$8iu__"